// Javascript ==================================================================
import * as Turbo from "../src/shared/vendor/turbo"
import * as bootstrap from 'bootstrap'
import "controllers/index_turbo"
import 'typeface-nunito'

import ScrollTo from "@appComponents/helpers/scroll-to"
import NavActive from "@appComponents/helpers/nav-active"
import HeaderFixed from "@appComponents/helpers/header-fixed"
import HomeLogo from "@appComponents/helpers/home-logo"
import MainMenu from "@appComponents/helpers/main-menu"
import InputSmooth from "@appComponents/helpers/input-smooth"
import "../src/shared/helpers/turbo-stream-transitions"
import { cleanupModalBody } from "../src/shared/helpers/modal_body_cleanup"
import { registerServiceWorker } from "../src/shared/register_service_worker"

// CSS =========================================================================
import "src/stylesheets/application.sass"

// Configuration ===============================================================
Turbo.session.drive = false
registerServiceWorker()

Turbo.StreamActions.redirect = function () {
  const url = this.getAttribute("url")
  if (url) Turbo.visit(url)
}

Turbo.StreamActions.frame_reload = function () {
  const frame = document.getElementById(this.getAttribute("target"))
  if (frame && frame.src) {
    frame.reload()
  }
}

Turbo.StreamActions.frame_set_src_and_reload = function () {
  const frameId = this.getAttribute("target")
  const src = this.getAttribute("src")

  if (!frameId || !src) return

  const frame = document.getElementById(frameId)
  if (!frame) return

  // Setting src to the current URL is a no-op in Turbo — force a refetch.
  const absoluteSrc = new URL(src, document.baseURI).href
  if (frame.src === absoluteSrc) {
    frame.reload()
  } else {
    frame.src = src
  }
}

Turbo.StreamActions.push_state = function () {
  const url = this.getAttribute("url")
  history.pushState({}, "", url)
}

Turbo.StreamActions.dismiss_modal = function () {
  const target = this.getAttribute("target")
  const modalElement = target ? document.getElementById(target) : null

  if (modalElement) {
    const modal = bootstrap.Modal.getInstance(modalElement) || bootstrap.Modal.getOrCreateInstance(modalElement)
    modal.hide()

    modalElement.addEventListener("hidden.bs.modal", function cleanup () {
      modalElement.removeEventListener("hidden.bs.modal", cleanup)
      cleanupModalBody()
    })
  }

  // Subsequent turbo streams may remove the modal before Bootstrap fires hidden.bs.modal.
  requestAnimationFrame(() => cleanupModalBody())
}

function lazyLoadTurboFrameOnModalShow (event) {
  const modal = event.target
  if (!modal.matches(".modal")) return

  const turboFrame = modal.querySelector("turbo-frame[data-lazy-src]")
  if (!turboFrame?.dataset.lazySrc) return

  turboFrame.src = turboFrame.dataset.lazySrc
}

document.addEventListener("shown.bs.modal", lazyLoadTurboFrameOnModalShow)

function hideTooltipsOnDropdownButtonClick () {
  const dropdownButtons = document.querySelectorAll("[data-bs-toggle='dropdown']")

  dropdownButtons.forEach(button => {
    button.addEventListener("click", () => {
      document.querySelectorAll("[data-controller~=\"tooltip\"]").forEach(tooltip => {
        const instance = bootstrap.Tooltip.getInstance(tooltip)
        if (instance) {
          instance.hide()
        }
      })
    })
  })
}

function hideTooltipsOnModalShow () {
  const modals = document.querySelectorAll(".modal")

  modals.forEach(modal => {
    modal.addEventListener("show.bs.modal", () => {
      // Disable all tooltips while modal is open
      document.querySelectorAll("[data-controller~=\"tooltip\"]").forEach(el => {
        const instance = bootstrap.Tooltip.getInstance(el)
        if (instance) {
          instance.update()
          instance.disable() // prevent any new show events
          instance.hide() // hide any currently visible tooltip
        }
      })
    })

    modal.addEventListener("hidden.bs.modal", () => {
      // Re-enable tooltips after modal is closed
      document.querySelectorAll("[data-controller~=\"tooltip\"]").forEach(el => {
        const instance = bootstrap.Tooltip.getInstance(el)
        if (instance) {
          instance.enable()
        }
      })
    })
  })
}

document.addEventListener("turbo:load", () => {
  hideTooltipsOnDropdownButtonClick()
  hideTooltipsOnModalShow()

  new NavActive()
  new HeaderFixed()
  new HomeLogo()
  new ScrollTo()
  new MainMenu()
  new InputSmooth()
})

document.addEventListener("turbo:frame-load", (event) => {
  // event.target is the <turbo-frame>
  hideTooltipsOnDropdownButtonClick()
  hideTooltipsOnModalShow()
})

export default Turbo
